/** @jsxImportSource theme-ui */
import { Button as ThemeUIButton, Box, Heading, useThemeUI } from "theme-ui";

import { useTranslation } from "hooks";
import { ProductButton } from "components";
import { ArrowLeftIcon } from "components/icons";
import * as styles from "./ProductsSelectorV1.styles";

export default function ProductsSelectorV1({
  title,
  products = [],
  selectedProduct,
  selectProduct,

  position,
  top,
  left,
  right,
  containerTop,
  labelTop,
  labelLeft,
}) {
  const {
    theme: { isDesktop },
  } = useThemeUI();
  const { t } = useTranslation();

  return (
    <Box sx={styles.container}>
      <Heading
        as="h1"
        sx={
          isDesktop
            ? styles.desktopHeading({ labelTop, labelLeft })
            : styles.heading
        }
      >
        {title}
      </Heading>

      <Box
        sx={
          isDesktop
            ? styles.desktopCardsContainer({ containerTop })
            : styles.cardsContainer
        }
      >
        {products
          .filter(({ id }) => !selectedProduct || id === selectedProduct.id)
          .filter((product) => product.id !== "QuickTurnSupremeStick")
          .map(({ id, category: { logo, productButtonProps } }) => (
            <Box
              key={id}
              sx={
                isDesktop
                  ? styles.desktopCard({ position, top, left, right })
                  : styles.card
              }
            >
              <ProductButton
                logo={logo}
                isSelected={id === selectedProduct?.id}
                onClick={() => {
                  selectProduct(id);
                }}
                {...productButtonProps}
              />

              {id === selectedProduct?.id && (
                <ThemeUIButton
                  variant="unstyled"
                  onClick={() => selectProduct("")}
                  sx={styles.changeStickButton}
                >
                  <ArrowLeftIcon />
                  {t("Change Stick")}
                </ThemeUIButton>
              )}
            </Box>
          ))}
      </Box>
    </Box>
  );
}
